import {HStack, Image, StackProps, Text} from '@chakra-ui/react'
import {useTranslate} from '@tolgee/react'

export interface LogoProps extends StackProps {
  fileVariant?: '192' | '512'
  size?: number
  hideText?: boolean
}

export function Logo({fileVariant = '192', size = 40, hideText, ...props}: LogoProps) {
  const {t} = useTranslate('common')

  return (
    <HStack {...props}>
      <Image src={`/logo${fileVariant}.png`} alt="Cypro logo" htmlWidth={size} htmlHeight={size} display="block" />

      {!hideText && (
        <Text fontSize="sm" fontWeight="medium">
          {t('app_name')} 2.0
        </Text>
      )}
    </HStack>
  )
}
